export default __webpack_public_path__ + "static/media/chrome-extension-loggedin.f695f8e1.svg";